{
  "slug": "raw-scores-vs-scaled-iq-scores",
  "title": "Raw Scores vs Scaled IQ Scores",
  "description": "Learn how correct answers become scaled scores, index scores, percentiles, and an IQ estimate.",
  "summary": "A raw score is a direct total from items. A scaled or composite score interprets that performance using test-specific norms and conversion rules.",
  "category": "Science of testing",
  "sections": [
    {
      "heading": "What a raw score is",
      "paragraphs": [
        "A raw score may count correct responses, points earned, or performance within a time limit. On its own, it usually says little because task difficulty and age expectations are not represented.",
        "Two subtests with the same raw total may have different meanings, and the same raw total can convert differently across age groups."
      ]
    },
    {
      "heading": "How scaling works",
      "paragraphs": [
        "Test publishers collect norm data and convert raw performance to standardized subtest scores. Selected subtests may then combine into index and overall composites.",
        "Percentile ranks describe relative standing, while confidence intervals express uncertainty around the estimate. Conversion rules are specific to each instrument and edition."
      ]
    },
    {
      "heading": "Why scores cannot be freely converted",
      "paragraphs": [
        "An online percentage correct is not automatically an IQ score. A conversion requires appropriate items, standard administration, representative norms, and evidence that the scale behaves as claimed.",
        "Do not compare numbers from different tests without checking their scales. Mensa emphasizes percentiles because qualifying tests may report results differently."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Is 80 percent correct equal to an IQ of 120?",
      "answer": "No. The conversion depends on item difficulty, norms, age, and the test’s scoring model."
    },
    {
      "question": "What is a scaled score?",
      "answer": "It is a transformed result placed on a defined scale so performance can be interpreted against the test’s norms."
    }
  ],
  "related": ["how-is-iq-measured", "iq-percentiles", "iq-score-confidence-intervals"],
  "sources": [
    {
      "label": "Pearson — WAIS-5 sample score report",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report-with-demographically-referenced-scores.pdf"
    },
    {
      "label": "Mensa International — getting your IQ tested",
      "url": "https://www.mensa.org/getting-your-iq-tested-faqs/"
    },
    {
      "label": "Standards for Educational and Psychological Testing",
      "url": "https://www.testingstandards.net/"
    }
  ]
}
